module.exports = __webpack_public_path__ + "img/toggle-rules2.9e83feb2.svg";